import React, { Component, Fragment } from 'react'
import '../../assets/css/style.css';

export default class DefaultLayout extends Component {
    render() {
        return (
            <Fragment>
                <div id="falcon" className="authentication" >
                    <div className="wrapper">
                        <div className="header header-filter osita">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 text-center">
                                        <div className="card card-signup" style={{ marginTop: 50 }}>
                                            {this.props.children}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <footer className="footer mt-20">
                                <div className="container">
                                    <div className="col-lg-12 text-center">
                                        <div className="copyright text-white mt-20"> Enugu Lifestyle &amp; Golf City © {new Date().getFullYear()}
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Content/SecondLayout.js